import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import Store from "./store";
import "./index.css";

function deferNonCriticalInit() {
  const googleAnalyticsMeasurementId = process.env.REACT_APP_GA_ID;
  const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

  if (!googleAnalyticsMeasurementId && !sentryDsn) return;

  const init = () => {
    if (sentryDsn) {
      Promise.all([
        import("@sentry/react"),
        import("@sentry/tracing"),
      ]).then(([Sentry, { BrowserTracing }]) => {
        Sentry.init({
          dsn: sentryDsn,
          integrations: [new BrowserTracing()],
          tracesSampleRate: 1.0,
        });
      });
    }

    if (googleAnalyticsMeasurementId) {
      import("react-ga4").then(({ default: ReactGA }) => {
        ReactGA.initialize(googleAnalyticsMeasurementId);
        ReactGA.send("pageview");
      });
    }
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(init, { timeout: 3000 });
  } else {
    window.setTimeout(init, 1);
  }
}

deferNonCriticalInit();

ReactDOM.render(
  <Provider store={Store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root"),
);
